// EN (primary) · RO · DE. Arabic removed.
// Structure matches the existing pages: Home, About, Services, Contact.

const WHATSAPP_PREFILLED = {
    en: "Hello OTHRYX, I am reaching out regarding a potential engineering project.",
    de: "Hallo OTHRYX, ich melde mich wegen eines möglichen Ingenieurprojekts.",
    ro: "Bună ziua OTHRYX, vă contactez în legătură cu un posibil proiect de inginerie.",
};

export const CONTACT = {
    domain: "www.othryx.de",
    domainPlain: "othryx.de",
    emailGeneral: "office@othryx.de",
    emailExec: "o.bahaaeddin@othryx.de",
    phoneDE_Display: "+49 176 41655739",
    phoneDE_Tel: "+4917641655739",
    phoneRO_Display: "+40 774 978 965",
    phoneRO_Tel: "+40774978965",
    whatsappBase: "https://wa.me/40774978965",
    whatsapp: "https://wa.me/40774978965",
    whatsappFor: (locale = "en") => {
        const msg = WHATSAPP_PREFILLED[locale] || WHATSAPP_PREFILLED.en;
        return `https://wa.me/40774978965?text=${encodeURIComponent(msg)}`;
    },
    addressShort: "Craiova, Dolj County, Romania",
    addressFull: "Craiova, Dolj County, Romania (EU Operations)",
};

const LEGAL = {
    impressum: `OTHRYX S.R.L. | Managing Director: Eng. Othman Bahaaeddin | Headquartered in Craiova, Romania | Operating under the EU 'Freedom to provide services' framework. | Official Website: www.othryx.de | Contact: office@othryx.de`,
    privacy: `In accordance with EU General Data Protection Regulation (GDPR), OTHRYX S.R.L. ensures total protection of B2B data, client inquiries, and project specifications submitted via www.othryx.de. No data is shared with third parties without explicit legal consent.`,
    cookie: `We use cookies to ensure the best experience on our corporate platform. By continuing to browse www.othryx.de, you accept our Privacy Policy.`,
};

export const translations = {
    en: {
        meta: { dir: "ltr", label: "EN", name: "English" },
        nav: { home: "Home", about: "About", services: "Services", contact: "Contact", cta: "Request Consultation" },
        common: {
            consult: "Request a B2B Consultation",
            partner: "Partner With Us",
            discuss: "Discuss Your Project",
            scroll: "Scroll to explore",
            since: "EU Operations",
        },
        home: {
            kicker: "Engineering · Consulting · Contracting",
            h1Line1: "European",
            h1Line2: "Engineering,",
            h1Line3: "Executed",
            h1Line4: "Without Friction.",
            sub: "OTHRYX S.R.L. partners with German and EU companies to deliver technical and electrical projects under one accountable B2B umbrella — fully compliant, insured, and engineered for precision.",
            stat1Label: "EU Compliance", stat1Value: "100%",
            stat2Label: "Framework", stat2Value: "Freedom to Provide Services",
            stat3Label: "Headquarters", stat3Value: "Craiova · Dolj · RO",
            valueProp: {
                overline: "Why OTHRYX",
                title: "One contractor. Zero administrative burden.",
                body: "By partnering with us on a B2B basis, you eliminate direct hiring overhead, complex paperwork, and exposure to local labour taxation. We supply engineering, supervision, and certified execution teams — under a single accountable signature.",
                points: [
                    "EU Freedom to Provide Services framework",
                    "Fully insured & compliant operations",
                    "Engineering supervision (Bauleitung) on-site",
                    "Skilled EU subcontractors managed end-to-end",
                ],
            },
            services: {
                overline: "Core Capabilities",
                title: "Built for the German engineering mindset.",
                items: [
                    { code: "01 / CAEN 7112", title: "Engineering & Technical Consultancy", body: "Project planning, technical design, blueprint analysis, smart-home systems architecture." },
                    { code: "02 / Bauleitung", title: "Project Management & Supervision", body: "On-site supervision ensuring delivery to strict EU standards, on time, within budget." },
                    { code: "03 / CAEN 4321", title: "Electrical Installations", body: "Wiring execution, smart systems integration, industrial electrical setups via certified teams." },
                    { code: "04 / Gewerbe", title: "General Contracting & Workforce", body: "Supplying & managing skilled EU subcontractors under one accountable contract." },
                ],
            },
            tape: ["Bauleitung", "EU Compliance", "Smart Systems", "Industrial Electrical", "Project Management", "B2B Contracting", "Workforce Supply", "Engineering Supervision"],
            cta: { title: "Have a project in Germany or the EU?", body: "Send us your scope. We will respond with a structured B2B proposal.", button: "Discuss Your Project" },
        },
        about: {
            kicker: "About OTHRYX",
            h1: "A European contractor engineered for German precision.",
            intro: "OTHRYX S.R.L. is a modern European engineering, technical consulting and general contracting firm headquartered in Craiova, Dolj County, Romania, with a strategic operational focus on the German and European markets. We operate under the EU 'Freedom to provide services' framework, offering seamless B2B solutions across borders via www.othryx.de.",
            missionTitle: "Mission",
            missionBody: "Help German and EU companies execute their technical and electrical projects smoothly and cost-effectively — eliminating administrative burdens, high direct-hiring taxes, and fragmented coordination.",
            modelTitle: "Operating Model",
            modelBody: "One corporate umbrella. Full project management, engineering supervision (Bauleitung), and certified EU execution teams. You sign with one party — OTHRYX is accountable end-to-end.",
            founderOverline: "Founder & General Manager",
            founderName: "Eng. Othman Bahaaeddin",
            founderBio: "Certified engineer with a strong academic background, currently pursuing a Master's degree in Romania. Combines deep technical engineering expertise with a sharp business and project-management mindset — ensuring that every project is technically sound and operationally efficient.",
            pillars: {
                title: "What guides every project",
                items: [
                    { n: "01", t: "Compliance", b: "Every operation runs within EU regulatory and tax frameworks." },
                    { n: "02", t: "Precision", b: "Engineering-led decisions, blueprint-accurate execution." },
                    { n: "03", t: "Accountability", b: "One contract, one accountable party — OTHRYX." },
                    { n: "04", t: "Efficiency", b: "Cost-optimised through skilled EU labour management." },
                ],
            },
        },
        services: {
            kicker: "Services",
            h1: "End-to-end delivery, under one accountable umbrella.",
            intro: "From early-stage technical design through on-site supervision and final commissioning — OTHRYX integrates engineering, electrical execution and workforce management into a single B2B contract.",
            items: [
                { code: "Service 01 — CAEN 7112", title: "Engineering & Technical Consultancy", desc: "Expert project planning, technical design, blueprint analysis, and smart home / building systems architecture. We translate your specification into executable engineering reality.", bullets: ["Technical feasibility & planning", "Blueprint review & coordination", "Smart systems architecture", "EU standards compliance review"] },
                { code: "Service 02 — Bauleitung", title: "Project Management & Supervision", desc: "On-site technical supervision ensuring projects are executed to strict EU standards, on time and within budget. Engineering presence, not just paperwork.", bullets: ["Bauleitung / on-site supervision", "Schedule & cost control", "Quality & safety assurance", "Stakeholder & subcontractor coordination"] },
                { code: "Service 03 — CAEN 4321", title: "Electrical Installations", desc: "Execution and management of electrical wiring, smart-systems integration, and industrial electrical setups — delivered through certified specialised teams.", bullets: ["Industrial & commercial wiring", "Smart-systems integration (KNX / IoT)", "Switchgear & distribution", "Testing, commissioning & handover"] },
                { code: "Service 04 — Gewerbe / Subcontracting", title: "General Contracting & Workforce", desc: "Supplying and managing skilled EU technical teams (Subcontractors / Gewerbe) for project execution — you deal with only one accountable contractor: OTHRYX.", bullets: ["Vetted EU technical workforce", "Single-contract accountability", "Compliance, insurance & payroll handled", "Scalable team sizing per phase"] },
            ],
            process: {
                title: "How we engage",
                steps: [
                    { n: "01", t: "Brief", b: "You send scope, drawings, or a project description. We sign an NDA if required." },
                    { n: "02", t: "Proposal", b: "Structured B2B proposal: scope, timeline, team composition, fixed pricing." },
                    { n: "03", t: "Mobilisation", b: "Certified teams mobilised under EU Freedom-to-provide-services framework." },
                    { n: "04", t: "Delivery", b: "Engineering supervision, weekly reporting, handover with full documentation." },
                ],
            },
        },
        contact: {
            kicker: "Contact",
            h1: "Let's discuss your project.",
            intro: "Reach our corporate office or executive management directly. Floating WhatsApp connects you to our Romania operations line; the direct-call button reaches our Germany line.",
            block1Title: "General Corporate Office",
            block1Email: CONTACT.emailGeneral,
            block2Title: "Executive Management — Eng. Othman Bahaaeddin",
            block2Email: CONTACT.emailExec,
            phoneDELabel: "Germany (Direct Line)",
            phoneROLabel: "Romania (Operations Line)",
            addressLabel: "Headquarters",
            hoursLabel: "Office Hours",
            hoursValue: "Mon – Fri · 09:00 – 18:00 CET",
            ctaMail: "Send Email",
            ctaCopy: "Copy email",
            copied: "Copied",
            subjectLine: "B2B Project Inquiry — OTHRYX",
            mailBody: "Hello OTHRYX team,\n\nProject location: \nScope / trade: \nApproximate volume: \nDesired start: \n\nBrief description:\n\n— Sent from www.othryx.de",
            formTitle: "Send Us a Brief Directly",
            formSub: "Your inquiry is delivered to our corporate inbox in addition to email. We respond within two business days.",
            form: {
                name: "Full name",
                email: "Email",
                company: "Company",
                phone: "Phone",
                subject: "Subject",
                message: "Project details / scope",
                submit: "Send Inquiry",
                sending: "Sending…",
                success: "Inquiry received. We will reply within two business days.",
                error: "Submission failed. Please retry or email office@othryx.de directly.",
                required: "Required field",
                invalidEmail: "Invalid email address",
            },
        },
        floating: { whatsapp: "WhatsApp · RO Operations", call: "Call · Germany" },
        cookie: { text: LEGAL.cookie, accept: "Accept", decline: "Decline" },
        legal: {
            impressumTitle: "Impressum",
            impressumBody: LEGAL.impressum,
            privacyTitle: "Privacy Policy (GDPR)",
            privacyBody: LEGAL.privacy,
            close: "Close",
        },
        seo: {
            home: { title: "OTHRYX S.R.L. — European Engineering, Executed", description: "B2B electrical engineering, project supervision and certified execution teams for German and EU clients. EU Freedom-to-provide-services framework." },
            about: { title: "About OTHRYX — Accredited European Engineering", description: "Romanian engineering and contracting firm with EU-recognised engineering credentials, headquartered in Craiova, Dolj County." },
            services: { title: "Services — OTHRYX S.R.L.", description: "Engineering & technical consultancy, project supervision (Bauleitung), electrical installations, general contracting under one accountable contract." },
            contact: { title: "Contact OTHRYX — B2B Inquiry", description: "Send a structured B2B inquiry, WhatsApp Romania operations or call our German direct line. Office: office@othryx.de" },
            impressum: { title: "Impressum — OTHRYX S.R.L.", description: "Legal notice for OTHRYX S.R.L. — Managing Director, headquarters, and EU framework." },
            privacy: { title: "Privacy Policy (GDPR) — OTHRYX S.R.L.", description: "GDPR-compliant privacy policy for B2B inquiries and project data submitted via www.othryx.de." },
            admin: { title: "OTHRYX Admin Inbox", description: "Internal inbox for B2B inquiries." },
        },
        admin: {
            title: "Inquiry Inbox",
            login: "Administrator Login",
            tokenLabel: "Admin Token",
            tokenPh: "Enter token…",
            enter: "Enter",
            logout: "Log out",
            empty: "No inquiries yet.",
            failed: "Authentication failed.",
            total: "Total",
            new: "New",
            markRead: "Mark read",
            markUnread: "Mark unread",
            delete: "Delete",
            confirmDelete: "Delete this inquiry permanently?",
            sentBy: "Sent by",
            sentAt: "Received",
            from: "Locale",
            details: "Details",
            replyEmail: "Reply via email",
        },
        footer: {
            tagline: "European Engineering, Executed.",
            framework: "Operating under the EU 'Freedom to provide services' framework. Fully compliant. Fully insured.",
            sections: { explore: "Explore", capabilities: "Capabilities", legal: "Legal & Compliance" },
            legal: ["Impressum", "Privacy Policy", "Cookie Settings"],
            copyright: "© {year} OTHRYX S.R.L. — All rights reserved.",
            hq: "Headquarters · Craiova, Dolj County, Romania",
            domain: CONTACT.domain,
        },
    },

    ro: {
        meta: { dir: "ltr", label: "RO", name: "Română" },
        nav: { home: "Acasă", about: "Despre Noi", services: "Servicii", contact: "Contact", cta: "Solicită Consultanță" },
        common: {
            consult: "Solicită o Consultanță B2B",
            partner: "Devino Partener",
            discuss: "Discută Proiectul",
            scroll: "Continuă explorarea",
            since: "Operațiuni UE",
        },
        home: {
            kicker: "Inginerie · Consultanță · Antrepriză",
            h1Line1: "Inginerie",
            h1Line2: "Europeană,",
            h1Line3: "Executată",
            h1Line4: "Fără Fricțiuni.",
            sub: "OTHRYX S.R.L. este partenerul companiilor din Germania și UE pentru livrarea proiectelor tehnice și electrice — sub o singură umbrelă B2B responsabilă: conformă, asigurată și executată cu precizie inginerească.",
            stat1Label: "Conformitate UE", stat1Value: "100%",
            stat2Label: "Cadru", stat2Value: "Libera prestare a serviciilor",
            stat3Label: "Sediu", stat3Value: "Craiova · Dolj · RO",
            valueProp: {
                overline: "De ce OTHRYX",
                title: "Un singur antreprenor. Zero povară administrativă.",
                body: "În parteneriat cu noi pe model B2B, eliminați costurile de angajare directă, birocrația complexă și expunerea la impozitarea locală. Furnizăm ingineria, supervizarea și echipele de execuție certificate — sub o singură semnătură responsabilă.",
                points: [
                    "Cadru UE — libera prestare a serviciilor",
                    "Operațiuni complet asigurate și conforme",
                    "Supervizare inginerească (Bauleitung) pe șantier",
                    "Subcontractori UE calificați, gestionați end-to-end",
                ],
            },
            services: {
                overline: "Capabilități Cheie",
                title: "Construit pentru mentalitatea inginerească germană.",
                items: [
                    { code: "01 / CAEN 7112", title: "Inginerie & Consultanță Tehnică", body: "Planificare, proiectare tehnică, analiză planuri, arhitectură sisteme inteligente." },
                    { code: "02 / Bauleitung", title: "Management de Proiect & Supervizare", body: "Supervizare pe șantier conform standardelor stricte UE, la timp și în buget." },
                    { code: "03 / CAEN 4321", title: "Instalații Electrice", body: "Execuție cablaje, integrare sisteme inteligente, instalații industriale cu echipe certificate." },
                    { code: "04 / Gewerbe", title: "Antrepriză & Forță de Muncă", body: "Punerea la dispoziție și gestionarea subcontractorilor UE sub un contract unic." },
                ],
            },
            tape: ["Bauleitung", "Conformitate UE", "Sisteme Inteligente", "Electrice Industriale", "Management de Proiect", "Contractare B2B", "Forță de Muncă", "Supervizare"],
            cta: { title: "Aveți un proiect în Germania sau UE?", body: "Trimiteți-ne scopul lucrării. Răspundem cu o propunere B2B structurată.", button: "Discută Proiectul" },
        },
        about: {
            kicker: "Despre OTHRYX",
            h1: "Un antreprenor european construit pe precizia germană.",
            intro: "OTHRYX S.R.L. este o firmă modernă europeană de inginerie, consultanță tehnică și antrepriză generală cu sediul în Craiova, județul Dolj, România, având un focus strategic pe piețele din Germania și restul UE. Operăm în cadrul UE 'Libera prestare a serviciilor' și livrăm soluții B2B fără frontiere prin www.othryx.de.",
            missionTitle: "Misiune",
            missionBody: "Sprijinim companiile din Germania și UE să execute proiecte tehnice și electrice eficient — eliminând povara administrativă, taxele de angajare ridicate și coordonarea fragmentată.",
            modelTitle: "Model Operațional",
            modelBody: "O singură umbrelă corporativă. Management de proiect complet, supervizare inginerească (Bauleitung) și echipe certificate UE — totul sub răspunderea OTHRYX.",
            founderOverline: "Fondator & Director General",
            founderName: "Ing. Othman Bahaaeddin",
            founderBio: "Inginer certificat cu pregătire academică solidă, urmează un program de masterat în România. Combină expertiza inginerească aprofundată cu o mentalitate clară de management de proiect — pentru lucrări corecte tehnic și eficiente operațional.",
            pillars: {
                title: "Ce ghidează fiecare proiect",
                items: [
                    { n: "01", t: "Conformitate", b: "Fiecare operațiune în cadrul reglementar și fiscal al UE." },
                    { n: "02", t: "Precizie", b: "Decizii conduse de ingineri, execuție conformă planurilor." },
                    { n: "03", t: "Responsabilitate", b: "Un singur contract, un singur responsabil — OTHRYX." },
                    { n: "04", t: "Eficiență", b: "Cost optimizat prin echipe UE calificate." },
                ],
            },
        },
        services: {
            kicker: "Servicii",
            h1: "Livrare end-to-end sub o singură umbrelă responsabilă.",
            intro: "De la proiectarea tehnică inițială până la supervizarea pe șantier și punerea în funcțiune — OTHRYX integrează ingineria, execuția electrică și gestionarea forței de muncă într-un singur contract B2B.",
            items: [
                { code: "Serviciu 01 — CAEN 7112", title: "Inginerie & Consultanță Tehnică", desc: "Planificare tehnică, proiectare, analiză de planuri și arhitectură pentru sisteme inteligente. Transformăm specificațiile dvs. în realitate inginerească executabilă.", bullets: ["Fezabilitate tehnică & planificare", "Verificare și coordonare planuri", "Arhitectură sisteme inteligente", "Verificare conformitate UE"] },
                { code: "Serviciu 02 — Bauleitung", title: "Management de Proiect & Supervizare", desc: "Supervizare tehnică pe șantier conform standardelor UE, la timp și în buget. Prezență inginerească reală, nu doar birocrație.", bullets: ["Bauleitung / supervizare pe șantier", "Control termene & costuri", "Asigurare calitate & siguranță", "Coordonare subcontractori"] },
                { code: "Serviciu 03 — CAEN 4321", title: "Instalații Electrice", desc: "Execuție și management al cablajelor, integrare sisteme inteligente și instalații electrice industriale prin echipe certificate.", bullets: ["Cablaje comerciale și industriale", "Integrare KNX / IoT", "Tablouri & distribuție", "Testare, punere în funcțiune, predare"] },
                { code: "Serviciu 04 — Gewerbe / Subcontractare", title: "Antrepriză & Forță de Muncă", desc: "Furnizarea și managementul echipelor tehnice UE (Subcontractori / Gewerbe) — un singur antreprenor responsabil: OTHRYX.", bullets: ["Forță de muncă UE verificată", "Responsabilitate într-un singur contract", "Conformitate, asigurare, salarizare incluse", "Dimensionare scalabilă pe etape"] },
            ],
            process: {
                title: "Cum colaborăm",
                steps: [
                    { n: "01", t: "Brief", b: "Trimiteți scopul, planurile sau o descriere a proiectului. NDA la cerere." },
                    { n: "02", t: "Ofertă", b: "Propunere B2B structurată: scope, calendar, echipă, preț fix." },
                    { n: "03", t: "Mobilizare", b: "Echipe certificate mobilizate sub cadrul UE de prestare a serviciilor." },
                    { n: "04", t: "Livrare", b: "Supervizare inginerească, raport săptămânal, predare cu documentație." },
                ],
            },
        },
        contact: {
            kicker: "Contact",
            h1: "Să discutăm proiectul dumneavoastră.",
            intro: "Contactați biroul corporativ sau direct managementul executiv. Butonul WhatsApp vă conectează la linia de operațiuni din România, iar butonul de apel direct la linia din Germania.",
            block1Title: "Birou Corporativ General",
            block1Email: CONTACT.emailGeneral,
            block2Title: "Management Executiv — Ing. Othman Bahaaeddin",
            block2Email: CONTACT.emailExec,
            phoneDELabel: "Germania (Linie Directă)",
            phoneROLabel: "România (Linie Operațiuni)",
            addressLabel: "Sediu",
            hoursLabel: "Program",
            hoursValue: "Luni – Vineri · 09:00 – 18:00 CET",
            ctaMail: "Trimite Email",
            ctaCopy: "Copiază email",
            copied: "Copiat",
            subjectLine: "Cerere Proiect B2B — OTHRYX",
            mailBody: "Bună ziua, echipă OTHRYX,\n\nLocație proiect: \nScop / domeniu: \nVolum aproximativ: \nStart dorit: \n\nDescriere scurtă:\n\n— Trimis de pe www.othryx.de",
            formTitle: "Trimite Direct un Brief",
            formSub: "Cererea ajunge în inboxul nostru corporativ pe lângă email. Răspundem în maxim două zile lucrătoare.",
            form: {
                name: "Nume complet",
                email: "Email",
                company: "Companie",
                phone: "Telefon",
                subject: "Subiect",
                message: "Detalii proiect / scop",
                submit: "Trimite Cererea",
                sending: "Se trimite…",
                success: "Cererea a fost primită. Vă răspundem în maxim două zile lucrătoare.",
                error: "Trimiterea a eșuat. Reîncercați sau scrieți direct la office@othryx.de.",
                required: "Câmp obligatoriu",
                invalidEmail: "Adresă de email invalidă",
            },
        },
        floating: { whatsapp: "WhatsApp · Operațiuni RO", call: "Apel · Germania" },
        cookie: {
            text: "Folosim cookies pentru o experiență optimă pe platforma noastră corporativă. Continuând navigarea pe www.othryx.de, acceptați Politica de Confidențialitate.",
            accept: "Accept",
            decline: "Refuz",
        },
        legal: {
            impressumTitle: "Impressum",
            impressumBody: LEGAL.impressum,
            privacyTitle: "Politica de Confidențialitate (GDPR)",
            privacyBody: "Conform Regulamentului General UE privind Protecția Datelor (GDPR), OTHRYX S.R.L. asigură protecția totală a datelor B2B, a cererilor clienților și a specificațiilor de proiect transmise prin www.othryx.de. Nicio informație nu este partajată cu terți fără consimțământ legal explicit.",
            close: "Închide",
        },
        seo: {
            home: { title: "OTHRYX S.R.L. — Inginerie Europeană Executată", description: "Inginerie electrică B2B, supervizare de proiect și echipe certificate de execuție pentru clienți din Germania și UE. Cadrul UE de prestare a serviciilor." },
            about: { title: "Despre OTHRYX — Inginerie Europeană Acreditată", description: "Firmă românească de inginerie și antrepriză cu diplome recunoscute la nivel UE, cu sediul în Craiova, județul Dolj." },
            services: { title: "Servicii — OTHRYX S.R.L.", description: "Inginerie & consultanță tehnică, supervizare de șantier (Bauleitung), instalații electrice, antrepriză sub un singur contract responsabil." },
            contact: { title: "Contact OTHRYX — Cerere B2B", description: "Trimiteți o cerere B2B structurată, WhatsApp operațiuni România sau apel direct linia germană. Birou: office@othryx.de" },
            impressum: { title: "Impressum — OTHRYX S.R.L.", description: "Notă legală pentru OTHRYX S.R.L. — Director General, sediu și cadru UE." },
            privacy: { title: "Politica de Confidențialitate (GDPR) — OTHRYX S.R.L.", description: "Politică de confidențialitate conformă GDPR pentru cererile B2B transmise prin www.othryx.de." },
            admin: { title: "Inbox Administrator OTHRYX", description: "Inbox intern pentru cereri B2B." },
        },
        admin: {
            title: "Inbox Cereri",
            login: "Autentificare Administrator",
            tokenLabel: "Token Administrator",
            tokenPh: "Introduceți tokenul…",
            enter: "Intră",
            logout: "Deconectare",
            empty: "Nicio cerere încă.",
            failed: "Autentificare eșuată.",
            total: "Total",
            new: "Noi",
            markRead: "Marchează citit",
            markUnread: "Marchează necitit",
            delete: "Șterge",
            confirmDelete: "Ștergeți definitiv această cerere?",
            sentBy: "Trimis de",
            sentAt: "Primit",
            from: "Limbă",
            details: "Detalii",
            replyEmail: "Răspunde pe email",
        },
        footer: {
            tagline: "Inginerie Europeană, Executată.",
            framework: "Operăm în cadrul UE 'Libera prestare a serviciilor'. Complet conformi. Complet asigurați.",
            sections: { explore: "Explorează", capabilities: "Capabilități", legal: "Legal & Conformitate" },
            legal: ["Impressum", "Politica de Confidențialitate", "Setări Cookies"],
            copyright: "© {year} OTHRYX S.R.L. — Toate drepturile rezervate.",
            hq: "Sediu · Craiova, județul Dolj, România",
            domain: CONTACT.domain,
        },
    },

    de: {
        meta: { dir: "ltr", label: "DE", name: "Deutsch" },
        nav: { home: "Start", about: "Über uns", services: "Leistungen", contact: "Kontakt", cta: "Beratung anfordern" },
        common: {
            consult: "B2B-Beratung anfordern",
            partner: "Partner werden",
            discuss: "Projekt besprechen",
            scroll: "Weiter scrollen",
            since: "EU-Betrieb",
        },
        home: {
            kicker: "Engineering · Beratung · Generalunternehmer",
            h1Line1: "Europäisches",
            h1Line2: "Engineering,",
            h1Line3: "reibungslos",
            h1Line4: "umgesetzt.",
            sub: "OTHRYX S.R.L. ist Partner deutscher und EU-Unternehmen für die Umsetzung technischer und elektrischer Projekte — unter einem verantwortlichen B2B-Dach: konform, versichert, präzise.",
            stat1Label: "EU-Konformität", stat1Value: "100%",
            stat2Label: "Rahmen", stat2Value: "Dienstleistungsfreiheit",
            stat3Label: "Hauptsitz", stat3Value: "Craiova · Dolj · RO",
            valueProp: {
                overline: "Warum OTHRYX",
                title: "Ein Auftragnehmer. Null Verwaltungsaufwand.",
                body: "Mit OTHRYX als B2B-Partner entfallen direkte Einstellungen, komplexe Bürokratie und steuerliche Risiken vor Ort. Wir liefern Engineering, Bauleitung und zertifizierte Ausführungsteams — unter einer einzigen verantwortlichen Unterschrift.",
                points: [
                    "EU-Dienstleistungsfreiheit als Rahmen",
                    "Vollständig versicherter, konformer Betrieb",
                    "Engineering-Bauleitung direkt vor Ort",
                    "Qualifizierte EU-Subunternehmer end-to-end gesteuert",
                ],
            },
            services: {
                overline: "Kernkompetenzen",
                title: "Gebaut für das deutsche Engineering-Mindset.",
                items: [
                    { code: "01 / CAEN 7112", title: "Engineering & Technische Beratung", body: "Projektplanung, technisches Design, Plananalyse, Smart-Home-Architektur." },
                    { code: "02 / Bauleitung", title: "Projektmanagement & Bauleitung", body: "Bauleitung vor Ort — strikte EU-Standards, im Termin, im Budget." },
                    { code: "03 / CAEN 4321", title: "Elektroinstallationen", body: "Verkabelung, Smart-Systems-Integration, Industrieelektrik durch zertifizierte Teams." },
                    { code: "04 / Gewerbe", title: "Generalunternehmer & Personal", body: "Steuerung qualifizierter EU-Subunternehmer unter einem Vertrag." },
                ],
            },
            tape: ["Bauleitung", "EU-Konformität", "Smart Systems", "Industrieelektrik", "Projektmanagement", "B2B-Vergabe", "Personalstellung", "Engineering-Supervision"],
            cta: { title: "Projekt in Deutschland oder der EU?", body: "Senden Sie uns Ihren Leistungsumfang. Wir antworten mit einem strukturierten B2B-Angebot.", button: "Projekt besprechen" },
        },
        about: {
            kicker: "Über OTHRYX",
            h1: "Ein europäischer Auftragnehmer, ausgelegt auf deutsche Präzision.",
            intro: "OTHRYX S.R.L. ist ein modernes europäisches Engineering-, Beratungs- und Generalunternehmen mit Hauptsitz in Craiova, Landkreis Dolj, Rumänien — mit strategischem Fokus auf den deutschen und europäischen Markt. Wir agieren im Rahmen der EU-Dienstleistungsfreiheit und liefern grenzübergreifende B2B-Lösungen über www.othryx.de.",
            missionTitle: "Auftrag",
            missionBody: "Deutsche und EU-Unternehmen befähigen, technische und elektrische Projekte reibungslos und wirtschaftlich umzusetzen — frei von Verwaltungsaufwand, Lohnsteuerrisiken und fragmentierter Koordination.",
            modelTitle: "Operatives Modell",
            modelBody: "Ein Unternehmensdach. Vollständiges Projektmanagement, Bauleitung und zertifizierte EU-Ausführungsteams. Sie unterschreiben mit einem Partner — OTHRYX ist end-to-end verantwortlich.",
            founderOverline: "Gründer & Geschäftsführer",
            founderName: "Ing. Othman Bahaaeddin",
            founderBio: "Zertifizierter Ingenieur mit fundiertem akademischem Hintergrund, derzeit im Masterstudium in Rumänien. Verbindet tiefe technische Expertise mit klarem unternehmerischen Denken — für Projekte, die technisch wie operativ überzeugen.",
            pillars: {
                title: "Was jedes Projekt leitet",
                items: [
                    { n: "01", t: "Konformität", b: "Jeder Vorgang innerhalb des EU-Regulierungs- und Steuerrahmens." },
                    { n: "02", t: "Präzision", b: "Engineering-geführte Entscheidungen, planungstreue Ausführung." },
                    { n: "03", t: "Verantwortung", b: "Ein Vertrag, ein Verantwortlicher — OTHRYX." },
                    { n: "04", t: "Effizienz", b: "Kostenoptimiert durch qualifizierte EU-Personalsteuerung." },
                ],
            },
        },
        services: {
            kicker: "Leistungen",
            h1: "End-to-End-Lieferung unter einem verantwortlichen Dach.",
            intro: "Von früher technischer Planung über die Bauleitung bis zur Inbetriebnahme — OTHRYX vereint Engineering, Elektroausführung und Personalsteuerung in einem B2B-Vertrag.",
            items: [
                { code: "Leistung 01 — CAEN 7112", title: "Engineering & Technische Beratung", desc: "Projektplanung, technisches Design, Plananalyse, Smart-Home-/Building-Architektur. Wir überführen Ihre Spezifikation in ausführbare Engineering-Realität.", bullets: ["Technische Machbarkeit & Planung", "Planprüfung & Koordination", "Smart-Systems-Architektur", "EU-Konformitätsprüfung"] },
                { code: "Leistung 02 — Bauleitung", title: "Projektmanagement & Bauleitung", desc: "Bauleitung vor Ort — sichert EU-Standards, Termine und Budget. Engineering-Präsenz statt reine Bürokratie.", bullets: ["Bauleitung / Vor-Ort-Aufsicht", "Termin- & Kostencontrolling", "Qualitäts- & Arbeitssicherheit", "Stakeholder-Koordination"] },
                { code: "Leistung 03 — CAEN 4321", title: "Elektroinstallationen", desc: "Ausführung und Steuerung von Verkabelung, Smart-Systems und Industrieelektrik — durch zertifizierte Fachteams und vertrauenswürdige Subunternehmer.", bullets: ["Gewerbe- & Industrieverkabelung", "Smart-Systems-Integration (KNX / IoT)", "Schaltanlagen & Verteilung", "Prüfung, Inbetriebnahme & Übergabe"] },
                { code: "Leistung 04 — Gewerbe / Subunternehmer", title: "Generalunternehmer & Personal", desc: "Bereitstellung und Steuerung qualifizierter EU-Fachteams (Gewerbe) — Sie haben einen einzigen verantwortlichen Auftragnehmer: OTHRYX.", bullets: ["Geprüfte EU-Fachkräfte", "Verantwortung in einem Vertrag", "Konformität, Versicherung & Abrechnung übernommen", "Skalierbare Teamgrößen je Phase"] },
            ],
            process: {
                title: "So arbeiten wir",
                steps: [
                    { n: "01", t: "Brief", b: "Sie senden Leistungsumfang, Pläne oder Projektbeschreibung. NDA bei Bedarf." },
                    { n: "02", t: "Angebot", b: "Strukturiertes B2B-Angebot: Umfang, Zeitplan, Team, Festpreis." },
                    { n: "03", t: "Mobilisierung", b: "Zertifizierte Teams unter EU-Dienstleistungsfreiheit." },
                    { n: "04", t: "Lieferung", b: "Bauleitung, Wochenreporting, Übergabe mit vollständiger Doku." },
                ],
            },
        },
        contact: {
            kicker: "Kontakt",
            h1: "Lassen Sie uns Ihr Projekt besprechen.",
            intro: "Erreichen Sie unser Firmenbüro oder direkt die Geschäftsleitung. Die schwebende WhatsApp-Schaltfläche verbindet Sie mit unserer Linie in Rumänien, die Direktanruftaste mit unserer Linie in Deutschland.",
            block1Title: "Allgemeines Firmenbüro",
            block1Email: CONTACT.emailGeneral,
            block2Title: "Geschäftsleitung — Ing. Othman Bahaaeddin",
            block2Email: CONTACT.emailExec,
            phoneDELabel: "Deutschland (Direkte Leitung)",
            phoneROLabel: "Rumänien (Betriebsleitung)",
            addressLabel: "Hauptsitz",
            hoursLabel: "Geschäftszeiten",
            hoursValue: "Mo – Fr · 09:00 – 18:00 MEZ",
            ctaMail: "E-Mail senden",
            ctaCopy: "E-Mail kopieren",
            copied: "Kopiert",
            subjectLine: "B2B-Projektanfrage — OTHRYX",
            mailBody: "Guten Tag OTHRYX-Team,\n\nProjektstandort: \nGewerk / Umfang: \nUngefähres Volumen: \nGewünschter Start: \n\nKurze Beschreibung:\n\n— Gesendet über www.othryx.de",
            formTitle: "Brief direkt senden",
            formSub: "Ihre Anfrage landet zusätzlich zur E-Mail in unserem Firmen-Posteingang. Wir antworten innerhalb von zwei Werktagen.",
            form: {
                name: "Vor- und Nachname",
                email: "E-Mail",
                company: "Unternehmen",
                phone: "Telefon",
                subject: "Betreff",
                message: "Projektdetails / Umfang",
                submit: "Anfrage senden",
                sending: "Wird gesendet…",
                success: "Anfrage eingegangen. Wir antworten innerhalb von zwei Werktagen.",
                error: "Senden fehlgeschlagen. Bitte erneut versuchen oder direkt an office@othryx.de schreiben.",
                required: "Pflichtfeld",
                invalidEmail: "Ungültige E-Mail-Adresse",
            },
        },
        floating: { whatsapp: "WhatsApp · RO-Betrieb", call: "Anruf · Deutschland" },
        cookie: {
            text: "Wir verwenden Cookies, um Ihnen die bestmögliche Erfahrung auf unserer Unternehmensplattform zu bieten. Wenn Sie www.othryx.de weiter nutzen, akzeptieren Sie unsere Datenschutzerklärung.",
            accept: "Akzeptieren",
            decline: "Ablehnen",
        },
        legal: {
            impressumTitle: "Impressum",
            impressumBody: LEGAL.impressum,
            privacyTitle: "Datenschutzerklärung (DSGVO)",
            privacyBody: "Gemäß der EU-Datenschutz-Grundverordnung (DSGVO) gewährleistet OTHRYX S.R.L. den umfassenden Schutz aller B2B-Daten, Kundenanfragen und Projektspezifikationen, die über www.othryx.de übermittelt werden. Es werden keine Daten ohne ausdrückliche rechtliche Einwilligung an Dritte weitergegeben.",
            close: "Schließen",
        },
        seo: {
            home: { title: "OTHRYX S.R.L. — Europäisches Engineering, umgesetzt", description: "B2B-Elektrotechnik, Bauleitung und zertifizierte Ausführungsteams für deutsche und EU-Kunden. EU-Dienstleistungsfreiheit." },
            about: { title: "Über OTHRYX — Anerkanntes europäisches Engineering", description: "Rumänisches Engineering- und Generalunternehmen mit EU-anerkannten Ingenieurdiplomen, Hauptsitz in Craiova, Landkreis Dolj." },
            services: { title: "Leistungen — OTHRYX S.R.L.", description: "Engineering & Beratung, Bauleitung, Elektroinstallationen, Generalunternehmertum unter einem verantwortlichen Vertrag." },
            contact: { title: "Kontakt OTHRYX — B2B-Anfrage", description: "Strukturierte B2B-Anfrage senden, WhatsApp RO-Betrieb oder Direktanruf in Deutschland. Büro: office@othryx.de" },
            impressum: { title: "Impressum — OTHRYX S.R.L.", description: "Impressum von OTHRYX S.R.L. — Geschäftsführung, Hauptsitz und EU-Rahmen." },
            privacy: { title: "Datenschutzerklärung (DSGVO) — OTHRYX S.R.L.", description: "DSGVO-konforme Datenschutzerklärung für B2B-Anfragen über www.othryx.de." },
            admin: { title: "OTHRYX Administrator-Posteingang", description: "Interner Posteingang für B2B-Anfragen." },
        },
        admin: {
            title: "Anfragen-Posteingang",
            login: "Administrator-Login",
            tokenLabel: "Admin-Token",
            tokenPh: "Token eingeben…",
            enter: "Einloggen",
            logout: "Abmelden",
            empty: "Noch keine Anfragen.",
            failed: "Anmeldung fehlgeschlagen.",
            total: "Gesamt",
            new: "Neu",
            markRead: "Als gelesen markieren",
            markUnread: "Als ungelesen markieren",
            delete: "Löschen",
            confirmDelete: "Diese Anfrage endgültig löschen?",
            sentBy: "Gesendet von",
            sentAt: "Empfangen",
            from: "Sprache",
            details: "Details",
            replyEmail: "Per E-Mail antworten",
        },
        footer: {
            tagline: "Europäisches Engineering, umgesetzt.",
            framework: "Tätig im Rahmen der EU-Dienstleistungsfreiheit. Vollständig konform. Vollständig versichert.",
            sections: { explore: "Entdecken", capabilities: "Leistungen", legal: "Recht & Compliance" },
            legal: ["Impressum", "Datenschutz", "Cookie-Einstellungen"],
            copyright: "© {year} OTHRYX S.R.L. — Alle Rechte vorbehalten.",
            hq: "Hauptsitz · Craiova, Landkreis Dolj, Rumänien",
            domain: CONTACT.domain,
        },
    },
};

export const LOCALES = ["en", "ro", "de"];
